export default "__VITE_ASSET__C8V2P1i9__"